import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import stylesCadastro from "../Cadastro.module.css";
import { Alert, Snackbar } from "@mui/material"
import UploadInput from "../../../../components/Inputs/UploadInput"
import ServConsultaAcesso from "../../../../services/login/servConsultaAcesso";

import { downloadConteudoBase64 } from "../../../../infra/utils/DownloadFile";

const Documentos = ({
        codigoSolicitacao, 
        documentos, 
        setOpenError, 
        setErrorMessage, 
        situacaoConsultaAcesso,
        setIsLoading, 
        setTypeAlert}) => {
    const { register } = useForm();
    const [severity, setSeverity] = useState("info");
    const [openUpload, setOpenUpload] = useState(false);
    const [uploadMessage, setUploadMessage] = useState("");
    const [documentosObrigatorios, setDocumentosObrigatorios] = useState([]);

    const editavel = situacaoConsultaAcesso === 1 || situacaoConsultaAcesso === 2 || situacaoConsultaAcesso === 4 ? true : false; 
        
    useEffect(() => {
        const handleDocumentos = () => {
            if(!documentos) return;
            
            documentos.map((doc) => {
                // Valida se limita extensões
                if(!doc.DefinirExtensoesValidas || doc.ExtensoesValidas.trim() === '') {
                    doc.ExtensoesValidas = '*';
                } 
            })
    
            setDocumentosObrigatorios(documentos);
        }

        handleDocumentos();
    }, [documentos]);

    const handleCloseInfo = (event, reason) => {
        if (reason  === 'clickaway') {
            setOpenUpload(false);
        }

        setOpenUpload(false);
    }

    const handleUploadArquivos = async (e) => {
        let target = e.target;
        let file = target.files ? target.files[0] : null;

        if(file === null) {
            setOpenError(true);
            return setErrorMessage("Selecione um arquvio");
        }

        try {
            const formData = new FormData();

            let nomeArquvioSeparadoPorPonto = file.name.split('.');
            const extensaoArquivo = nomeArquvioSeparadoPorPonto.pop();
            const nomeArquivo = nomeArquvioSeparadoPorPonto.join('.');
            const size = file.size / 1024;

            formData.append("Arquivo", file);
            formData.append("CodigoConsultaAcesso", codigoSolicitacao);

            const id = e.target.id;
            let codigos = id.split("-");

            if (codigos[5] != 0) {
                formData.append("CodigoDocumento", codigos[5]);    
            }

            if(codigos[7] !== '*' && !codigos[7].includes(extensaoArquivo)) {
                setOpenError(true);
                setIsLoading(false);
                setTypeAlert("error");
                setErrorMessage(`Não é possível adicionar arquivos com a extensão "${extensaoArquivo}".`);
                return;
            }

            formData.append("CodigoConfiguracaoDoc", codigos[3]);
            formData.append("CodigoClassificacaoDoc", codigos[1]);
            formData.append("NomeArquivo", nomeArquivo);

            formData.append("ExtensaoArquivo", extensaoArquivo);
            formData.append("TamanhoKbArquivo", Math.trunc(size));

            setOpenUpload(true);
            setSeverity("info");
            setUploadMessage("Upload de arquivo iniciado");

            setTimeout(() => {
                setOpenUpload(false);
            }, [3000]);

            setIsLoading(true);
            let response = await ServConsultaAcesso.InserirDocumentoNaConsulta(formData);

            documentosObrigatorios.map((documento) => {
                if (documento.Id == codigos[3]) {
                    documento.CodigoDocumento = parseInt(response.Content);
                    documento.NomeArquivo = file.name;
                }
                return documento;
            });

            setOpenUpload(true);
            setSeverity("success");
            setUploadMessage("Arquivo enviado com sucesso");
            setIsLoading(false);
            setTimeout(() => {
                setOpenUpload(false);
            }, [1000]);
        } catch (err) {
            setTypeAlert("error");
            setOpenError(true);
            setIsLoading(false);
            let statusErrorMessage = err.response.status + " - " + err.response.statusText;

            setErrorMessage(err.response.data.Message ? err.response.data.Message : statusErrorMessage);
        }
    }

    const handleDownloadArquivo = async (event) => {
        event.preventDefault();

        let codigoDocumento = Number(event.currentTarget.value);

        if (!codigoDocumento) {
            setOpenError(true);
            return setErrorMessage("Não há documento vinculado para download.");
        }

        try {
            setIsLoading(true);

            let response = await ServConsultaAcesso.RealizarDownloadDocumento(codigoDocumento);
            downloadConteudoBase64(response.Content.Nome, response.Content.Arquivo);
            
            setUploadMessage("Arquivo enviado com sucesso");
            setIsLoading(false);
        } catch (err) {
            setOpenError(true);
            setIsLoading(false);
            let statusErrorMessage = err?.response?.status + " - " + err?.response?.statusText;

            setErrorMessage(err?.response?.data?.Message ? err?.response?.data?.Message : statusErrorMessage);
        }
    }

    const handleRemoverArquivo = async (event) => {
        event.preventDefault();

        let codigoDocumento = Number(event.currentTarget.value);

        if (!codigoDocumento) {
            setOpenError(true);
            return setErrorMessage("Não há documento vinculado para download.");
        }

        try {
            setIsLoading(true);

            await ServConsultaAcesso.RemoverDocumento(codigoDocumento);
            
            setDocumentosObrigatorios((prev) =>
            prev.map((doc) => {
                if (doc.CodigoDocumento === codigoDocumento) {
                    return {
                        ...doc,
                        CodigoDocumento: null,
                        NomeArquivo: null
                    };
                }
                return doc;
            }));

            setOpenUpload(true);
            setSeverity("success");
            setUploadMessage("Arquivo excluído com sucesso");
            setIsLoading(false);
        }
        catch(err) {
            setOpenUpload(true);
            setIsLoading(false);
            setSeverity("error");
            let statusErrorMessage = err?.response?.status + " - " + err?.response?.statusText;

            setUploadMessage(err?.response?.data?.Message ? err?.response?.data?.Message : statusErrorMessage);
        }
    }

    return (
        <div>
            <div className={stylesCadastro['cadastro-documentos']}>
                { documentosObrigatorios !== null ? documentosObrigatorios && documentosObrigatorios?.map((doc) => (
                    <div className={stylesCadastro['upload-field']} key={`classifDoc-${doc.CodigoClassificacaoDoc}-configdoc-${doc.Id ?? 0}-codigodoc-${doc.CodigoDocumento ?? 0}`}>
                        <UploadInput 
                            handleUploadArquivos={handleUploadArquivos} 
                            handleDownloadArquivo={handleDownloadArquivo}
                            handleRemoverArquivo={handleRemoverArquivo}
                            id={`classifDoc-${doc.CodigoClassificacaoDoc}-configdoc-${doc.Id}-codigodoc-${doc.CodigoDocumento ?? 0}-extensoes-${doc.ExtensoesValidas}`} 
                            label={doc.Descricao} 
                            register={register} 
                            registerName={doc.Descricao.replace('/\s/g', '-')}
                            obrigatorio={doc.Obrigatorio} 
                            codigoDocumento={doc.CodigoDocumento || 0} 
                            disabled={editavel} 
                            nomeArquivo={doc.NomeArquivo}
                            origemSolicitacao={true}
                            criterioAereo={doc.CriterioAereo}
                            criterioSubterraneo={doc.CriterioSubterraneo}
                            criterioMinigeracao={doc.CriterioMinigeracao}
                            criterioMicrogeracao={doc.CriterioMicrogeracao}
                            extensoesValidas={doc.ExtensoesValidas}
                        />   
                    </div> 
                )) : null }
            </div>
            <Snackbar open={openUpload} anchorOrigin={{ vertical: 'top', horizontal: 'right' }} autoHideDuration={1000} onClose={handleCloseInfo}>
                <Alert onClose={handleCloseInfo} severity={severity} sx={{ width: '100%'}} >
                    {uploadMessage}
                </Alert>
            </Snackbar>
        </div>
    )
}

export { Documentos }